import type { SliceStateCreator } from "../../types";
import type { ChatRoomsSliceState } from "./types";

export const createChatRoomsSlice: SliceStateCreator<
  ChatRoomsSliceState
> = () => ({
  chatRoomMap: new Map(),
  chatRoomStateMap: new Map(),
});
